import { combineReducers } from 'redux';
import draft from './drafts_reducer';
import contract from './contract_reducer';

const rootReducer = combineReducers({
    draft, contract
});

export default rootReducer;